webpackJsonp([105],{

/***/ 3118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        name: ''
      },
      formRules: {
        name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }, { max: 200, message: '公司名称长度不能超过200个字符', trigger: 'blur' }]
      }
    };
  },


  computed: {
    id: function id() {
      return this.$route.params.id;
    }
  },

  created: function created() {
    if (this.id) {
      this.loadData();
    }
  },


  methods: {
    loadData: function loadData() {
      var _this = this;

      request.page('workInfoCompanyGet', this.id).then(function (_ref) {
        var data = _ref.data;

        _this.form = {
          name: data.name || ''
        };
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) {
          return false;
        }

        var api = _this2.id ? 'workInfoCompanyEdit' : 'workInfoCompanyCreate';
        var params = _this2.id ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: _this2.id }, _this2.form) : _this2.form;

        request.common(api, params).then(function (_ref2) {
          var data = _ref2.data;

          _this2.$message({
            showClose: true,
            message: _this2.id ? '修改成功' : '添加成功',
            type: 'success'
          });
          _this2.$router.push({ name: '职业信息公司' });
        });
      });
    }
  }
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkInfoCompanyForm_vue__ = __webpack_require__(3118);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dafae4f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkInfoCompanyForm_vue__ = __webpack_require__(5880);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkInfoCompanyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dafae4f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkInfoCompanyForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("职业信息管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/work-info-company/table' }}},[_vm._v("职业信息公司")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"公司名称","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入公司名称","clearable":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),(_vm.id)?_c('el-alert',{staticStyle:{"margin-top":"8px"},attrs:{"type":"info","closable":false,"show-icon":""}},[_c('template',{slot:"default"},[_vm._v("\n                修改公司名称后只对新提交的职业信息审批生效，已提交的职业信息中的公司名称不会受影响。\n              ")])],2):_vm._e()],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","native-type":"submit"}},[_vm._v("保存\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-back"},on:{"click":function($event){return _vm.$router.push({name: '职业信息公司'})}}},[_vm._v("取消\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/WorkInfoCompanyForm.dadd8211857271ca28f8.js